import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms a date to the format: MM/dd/yyyy HH:mm a Z
 */
@Pipe({
	name: 'FullDate'
})
export class FullDatePipe implements PipeTransform {

// #region [ Implemented Methods ]

	/**
	 * Transforms a date into the MM/dd/yyyy HH:mm a Z format.
	 *
	 * @param Value The date to transform.
	 * @returns A string representing the date or an empty string if the date is null.
	 */
	transform(Value: string): string {
		let strDate, strOffset: string;
		let intHours, intOffset: number;
		let objValue: Date;

		if (Value == null || Value == "")
			return "";
		else {
			objValue = new Date(Date.parse(Value));

			// Get the hours value based on a 12 hour clock.
			intHours = objValue.getHours();
			if (intHours > 12)
				intHours = intHours - 12;

			// Get the timezone offset.
			intOffset = parseInt((objValue.getTimezoneOffset() / 60).toString());
			if (intOffset >= 0)
				strOffset = `+${intOffset}`;
			else
				strOffset = intOffset.toString();

			// Calculate the date string.
			strDate = this.PadString((objValue.getMonth() + 1).toString(), "0", 2) +
				"/" +
				this.PadString(objValue.getDate().toString(), "0", 2) +
				"/" +
				this.PadString(objValue.getFullYear().toString(), "0", 4) +
				" " +
				this.PadString(intHours.toString(), "0", 2) +
				":" +
				this.PadString(objValue.getMinutes().toString(), "0", 2) +
				" " +
				(objValue.getHours() >= 12 ? "PM" : "AM") +
				" " +
				strOffset + "H";

			return strDate;
		}
	}

// #region [ Private Methods ]

	/**
	 * Pads the left side of a string with a character.
	 *
	 * @param Value  The initial value of the string.
	 * @param Pad    The character to pad the string with.
	 * @param Length The desired length of the string.
	 * @returns The Value parameter padded with the Pad parameter until it is equal in length to the Legnth parameter.
	 */
	private PadString(Value: string, Pad: string, Length: number): string {
		if (Value == null || Length == null || Length <= 0 || Pad == null || Pad == "")
			return "";
		else {
			while (Value.length < Length)
				Value = Pad + Value;
			return Value;
		}
	}

}